import ApartsBlock from "../components/blocks/aparts-block";
import FindMyShop from "../components/blocks/find-my-shop";
import FindNow from "../components/blocks/find-now";
import OurBusinessArea from "../components/blocks/our-business-area";
import Subscribe from "../components/blocks/subscribe";
import ThreeReasons from "../components/blocks/three-reasons";
import Top3 from "../components/blocks/top3-values";
import Header from "../components/header";
import LeftMenu from "../components/left-menu";
import MainPageContentBlock from "../components/main-page-content-block";
import Slideshow from "../components/slideshow";
import "../styles/main.scss";
import "../styles/apart.scss";
import { useEffect, useState } from "react";
import { MobileView, isMobile } from "react-device-detect";
import SocialLinks from "../components/social-links";
import ContactsCard from "../components/contacts-card";
import Footer from "../components/footer";
import OurServices from "../components/our-services";
import { useLocation } from "react-router-dom";
import AboutUs from "../components/blocks/aboutus";
import Reviews from "../components/blocks/reviews";
import Socials from "../components/blocks/socials";

export default function Main(){
    const [showContacts, setshowcontacts] = useState(false);

    const { hash } = useLocation();
    function showContactsClick(){
        setshowcontacts(true);
    }
    function hideContactsClick(){
        setshowcontacts(false);
    }    
    useEffect(() => {   
        //preload();     
        if(hash=="#services")
            setTimeout(() => {                
                goToAnchor('our-services');
            }, 1000); 
        else
            setTimeout(() => {                
                goToAnchor('main-page-content');
            }, 500); 
    }, []);

    function goToAnchor(anchor){
        const posy = document.getElementById(anchor)?.getBoundingClientRect().top;
        document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });   
        const yOffset = -160; 
        const y = posy + window.scrollY + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
    }

    return (
        <>
            <Header/>
             <h1 style={{"position":"fixed","zIndex":"-5"}}>
            Mots clés en français:
Agence immobilière Yaoundé|LM PLATINUM ESTATES 
Agence immobilière Yaoundé Bastos|LM PLATINUM ESTATES
Agent immobilier Yaoundé |LM PLATINUM ESTATES
Agent immobilier Yaoundé Cameroun |LM PLATINUM ESTATES 
Agence immobilière Douala Cameroun |LM PLATINUM ESTATES
Société immobilière Cameroun |LM PLATINUM ESTATES
Agence immobilière Kribi Cameroun |LM PLATINUM ESTATES
Société Immobilière Yaoundé Cameroun |LM PLATINUM ESTATES
Société Immobilière Douala Cameroun |LM PLATINUM ESTATES
Terrain à vendre Yaounde Omnisport |LM PLATINUM ESTATES
Terrain à vendre Yaounde Odza |LM PLATINUM ESTATES
Terrain à vendre Yaoundé Nkoabang |LM PLATINUM ESTATES
Terrain à vendre Yaounde Nsimalen |LM PLATINUM ESTATES
Vente et achats de terrains à Yaoundé et alentours |LM PLATINUM ESTATES
Annonces immobilières Cameroun |LM PLATINUM ESTATES
Offres immobilières Yaoundé et Douala Cameroun |LM PLATINUM ESTATES
Petites annonces immobilières Kribi Cameroun |LM PLATINUM ESTATES
Annonces immobilières diasporas camerounaise|LM PLATINUM ESTATES
Achat immobilier Cameroun |LM PLATINUM ESTATES
Vente et location des biens immobiliers Douala Cameroun |LM PLATINUM ESTATES
Immatriculation et lotissement des terrains au Cameroun |LM PLATINUM ESTATES
Achat de terrain au Cameroun et établissement des dossiers techniques |LM PLATINUM ESTATES
Agence immobilière LM PLATINUM ESTATES Yaounde Cameroun 
Construction de maisons clés en main au Cameroun |LM PLATINUM ESTATES
Forage au Cameroun |LM PLATINUM ESTATES
Faire une mutation par décès au Cameroun LM PLATINUM ESTATES 
Procédures foncières au Cameroun |LM PLATINUM ESTATES
Maisons à vendre à Yaounde Cameroun |LM PLATINUM ESTATES
Maisons et appartements à louer Yaoundé |LM PLATINUM ESTATES
Bureaux à louer Yaoundé Bastos |LM PLATINUM ESTATES
Boutiques à louer Douala Cameroun |LM PLATINUM ESTATES
            </h1> 
            <div id="page">
                {!isMobile ? <div className="left-menu">
                    <LeftMenu/>
                </div> : ""}
                <div className="main-page-content">      
                   <Slideshow showContacts={showContactsClick}/>
                    <MainPageContentBlock id="aparts" content={<ApartsBlock/>}/>
                    <OurServices showContactsClick={showContactsClick} />
                    <Reviews/>
                    <Socials/>
                    <MainPageContentBlock  content={<FindNow showContactsClick={showContactsClick}/>}/>
                    <MainPageContentBlock id="why" content={<ThreeReasons/>}/>
                    <MainPageContentBlock id="fmshop" content={<FindMyShop showContactsClick={showContactsClick}/>}/>
                    <MainPageContentBlock id="about-us" content={<AboutUs/>}/> 
                    <MainPageContentBlock id="aboutus" content={<OurBusinessArea showContactsClick={showContactsClick}/>}/>
                 </div>  

                 
            </div>

            {showContacts ? <div className="contacts-modal">
                    <ContactsCard closeModal={hideContactsClick}/>
                 </div>
                 :
                 ""}  
        </>
    )
}